(() => {
    const buttons = document.querySelectorAll('.homepage-header__button-container .button');

    let width = 0;
    buttons.forEach((button) => {
        width = Math.max(width, button.getBoundingClientRect().width);
    });

    buttons.forEach((button) => {
        button.style.minWidth = `${width}px`;
    });
})();
